import { render, staticRenderFns } from "./InvestmentTable.vue?vue&type=template&id=e6b903c0&scoped=true&"
import script from "./InvestmentTable.vue?vue&type=script&lang=js&"
export * from "./InvestmentTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentTable.vue?vue&type=style&index=0&id=e6b903c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b903c0",
  null
  
)

export default component.exports